module.exports = __webpack_public_path__ + "img/icon_h-home-center.636f0be3.png";